var _circle, _path, _path2, _circle2, _circle3, _circle4, _path3, _g, _g2, _path4, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _g4, _rect6, _rect7, _rect8, _rect9, _rect10, _g5, _circle5, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhoopsie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 243,
    viewBox: "0 0 302 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 154.1,
    cy: 116.539,
    r: 116.27,
    fill: "url(#paint0_linear_1443_6601)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.766 143.048C150.976 146.339 156.267 146.339 159.477 143.048L231.82 68.8835H246.876C253.33 68.8835 258.562 74.1153 258.562 80.5689V169.098C258.562 175.552 253.33 180.784 246.876 180.784H61.4784C55.0247 180.784 49.793 175.552 49.793 169.098V80.5689C49.793 74.1153 55.0247 68.8835 61.4784 68.8835H75.423L147.766 143.048Z",
    fill: "url(#paint1_linear_1443_6601)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.848 8.20129C97.3938 8.20129 92.1621 13.433 92.1621 19.8867V67.77H93.0263C93.2081 70.6097 94.4435 73.4417 96.9579 75.6717L146.205 119.349C150.629 123.273 157.288 123.273 161.712 119.349L210.959 75.6717C213.474 73.4417 214.709 70.6097 214.891 67.77H215.753V19.8867C215.753 13.433 210.521 8.20129 204.068 8.20129H103.848ZM117.156 39.9342C117.156 38.0894 118.652 36.5939 120.497 36.5939H187.859C189.704 36.5939 191.2 38.0894 191.2 39.9342C191.2 41.779 189.704 43.2745 187.859 43.2745H120.497C118.652 43.2745 117.156 41.779 117.156 39.9342ZM120.497 58.8626C118.652 58.8626 117.156 60.3581 117.156 62.2029C117.156 64.0477 118.652 65.5432 120.497 65.5432H187.859C189.704 65.5432 191.2 64.0477 191.2 62.2029C191.2 60.3581 189.704 58.8626 187.859 58.8626H120.497Z",
    fill: "url(#paint2_linear_1443_6601)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.8136,
    cy: 32.6969,
    r: 7.18221,
    stroke: "#6B3BF1",
    strokeWidth: 2.33708
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.352,
    cy: 104.217,
    r: 5.79042,
    stroke: "#6B3BF1",
    strokeWidth: 2.33708
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.784,
    cy: 200.269,
    r: 4.39863,
    stroke: "#6B3BF1",
    strokeWidth: 2.33708
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6163 192.557C77.066 191.778 78.1905 191.778 78.6402 192.557L84.8125 203.248C85.2623 204.027 84.7 205.001 83.8005 205.001H71.456C70.5565 205.001 69.9942 204.027 70.444 203.248L76.6163 192.557Z",
    fill: "#6B3BF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1443_6601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.164 105.627L43.0436 110.706L48.123 112.586L43.0436 114.465L41.164 119.545L39.2845 114.465L34.2051 112.586L39.2845 110.706L41.164 105.627Z",
    fill: "#6B3BF1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1443_6601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.173 213.528L196.706 223.077L206.256 226.611L196.706 230.144L193.173 239.694L189.639 230.144L180.09 226.611L189.639 223.077L193.173 213.528Z",
    fill: "#6B3BF1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.485 19.5505L218.417 27.4744L226.341 30.4065L218.417 33.3386L215.485 41.2625L212.553 33.3386L204.629 30.4065L212.553 27.4744L215.485 19.5505Z",
    fill: "#6B3BF1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1443_6601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3903 82.6155C43.3908 77.2343 64.0053 63.8087 72.3401 54.6873C90.7589 74.0582 123.072 88.0136 142.135 93.7402L95.3721 127.723C80.0626 123.834 48.5905 101.779 23.3903 82.6155Z",
    fill: "url(#paint3_linear_1443_6601)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.1055,
    y: 87.2651,
    width: 32.5726,
    height: 3.39383,
    rx: 1.69691,
    transform: "rotate(-32.0168 48.1055 87.2651)",
    fill: "#D3D5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.2383,
    y: 94.1057,
    width: 39.7686,
    height: 3.39383,
    rx: 1.69691,
    transform: "rotate(-32.0168 54.2383 94.1057)",
    fill: "#D3D5FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.9082,
    y: 112.303,
    width: 39.7686,
    height: 3.39383,
    rx: 1.69691,
    transform: "rotate(-32.0168 76.9082 112.303)",
    fill: "#D3D5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7012,
    y: 100.496,
    width: 21.6249,
    height: 3.39383,
    rx: 1.69691,
    transform: "rotate(-32.0168 60.7012 100.496)",
    fill: "#D3D5FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67.9707,
    y: 106.597,
    width: 44.4848,
    height: 3.39383,
    rx: 1.69691,
    transform: "rotate(-32.0168 67.9707 106.597)",
    fill: "#D3D5FF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1443_6601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.664 118.036C256.009 120.637 224.731 99.8294 206.902 90.3896C185.59 118.372 152.404 139.658 128.29 149.886L189.983 187.374C209.45 180.09 247.452 146.721 277.664 118.036Z",
    fill: "url(#paint4_linear_1443_6601)"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 42.8631,
    height: 4.46602,
    rx: 2.23301,
    transform: "matrix(-0.887548 -0.460714 -0.460714 0.887548 246.275 128.907)",
    fill: "#D3D5FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 44.4537,
    height: 4.46602,
    rx: 2.23301,
    transform: "matrix(-0.887548 -0.460714 -0.460714 0.887548 238.949 138.526)",
    fill: "#D3D5FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 52.3325,
    height: 4.46602,
    rx: 2.23301,
    transform: "matrix(-0.887548 -0.460714 -0.460714 0.887548 211.125 164.78)",
    fill: "#D3D5FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 28.4567,
    height: 4.46602,
    rx: 2.23301,
    transform: "matrix(-0.887548 -0.460714 -0.460714 0.887548 231.145 147.588)",
    fill: "#D3D5FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 44.9171,
    height: 4.46602,
    rx: 2.23301,
    transform: "matrix(-0.887548 -0.460714 -0.460714 0.887548 222.248 156.355)",
    fill: "#D3D5FF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1443_6601)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 222.933,
    cy: 80.5746,
    r: 22.2687,
    fill: "#FF8888"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.933,
    cy: 76.1208,
    r: 22.2687,
    fill: "#FF4F75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.684 79.0248C220.071 74.4383 226.293 73.4159 226.293 70.5822C226.293 68.8001 224.891 67.8069 222.583 67.8069C220.801 67.8069 219.34 68.6248 217.909 70.1147L215.513 67.9237C217.383 65.7619 219.954 64.3305 223.08 64.3305C227.316 64.3305 230.412 66.317 230.412 70.2024C230.412 74.4675 224.014 74.9934 224.482 79.0248H220.684ZM222.612 86.8248C221.093 86.8248 220.012 85.744 220.012 84.2248C220.012 82.7057 221.122 81.6541 222.612 81.6541C224.073 81.6541 225.183 82.7057 225.183 84.2248C225.183 85.744 224.073 86.8248 222.612 86.8248Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1443_6601",
    x: 31.868,
    y: 103.29,
    width: 18.5921,
    height: 18.5921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16854,
    result: "effect1_foregroundBlur_1443_6601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1443_6601",
    x: 177.753,
    y: 211.191,
    width: 30.8402,
    height: 30.8398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16854,
    result: "effect1_foregroundBlur_1443_6601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1443_6601",
    x: 0.0198383,
    y: 43.0019,
    width: 165.486,
    height: 119.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.6854
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6854
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0533333 0 0 0 0 0 0 0 0 0 0.266667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1443_6601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1443_6601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1443_6601",
    x: 104.92,
    y: 78.7043,
    width: 196.115,
    height: 143.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.6854
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6854
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.13627 0 0 0 0 0 0 0 0 0 0.4375 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1443_6601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1443_6601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1443_6601",
    x: 183.136,
    y: 40.7778,
    width: 79.5933,
    height: 79.5935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.76404,
    result: "effect1_foregroundBlur_1443_6601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1443_6601",
    x1: 154.1,
    y1: 0.269653,
    x2: 154.1,
    y2: 232.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DED9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1443_6601",
    x1: 154.177,
    y1: 68.8835,
    x2: 154.177,
    y2: 180.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1443_6601",
    x1: 153.958,
    y1: 8.20129,
    x2: 153.958,
    y2: 122.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1443_6601",
    x1: 108.233,
    y1: 99.8542,
    x2: 66.3565,
    y2: 83.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1443_6601",
    x1: 169.159,
    y1: 152.766,
    x2: 221.528,
    y2: 124.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoopsie);
export default __webpack_public_path__ + "static/media/whoopsie.716a1e001e9314c426a6483bf73c2746.svg";
export { ForwardRef as ReactComponent };